import { userSlice } from "@/redux/User";
import { axiosGet } from "@/services/axiosService";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isAnalystRole } from "@/utils/contactsChatsAccess";

export default function useGetCredits(fallbackCreditId?: string) {
  const dispatch = useDispatch();
  const reduxCreditId = useSelector((state: any) => state.user.creditId);
  const role = useSelector((state: any) => state.user.role);
  const creditId = reduxCreditId || fallbackCreditId;

  const query = useQuery({
    queryKey: ["getCredits", creditId],
    enabled: !!creditId && !isAnalystRole(role),
    queryFn: async () => {
      const response = await axiosGet(`/users/getCredits`);
      return {
        creditUsed: response.data.creditUsed,
        creditLimit: response.data.creditLimit,
      };
    },
    staleTime: 0, // always refetch when creditId changes (e.g. company switch)
    gcTime: 0, // don't keep stale credit data from the previous company
  });

  useEffect(() => {
    if (query.data?.creditUsed !== undefined) {
      dispatch(userSlice.actions.setCreditUsed(query.data.creditUsed));
    }
  }, [query.data?.creditUsed, dispatch]);

  return query;
}
